import Image from '../PageElements/Image/Image';
import TextWithReferences from '../PageElements/TextWithReferences/TextWithReferences';

type Properties = {
    card: {
        term: string;
        frontImageId?: string;
        desc: string;
        backImageId?: string;
    };
    className: string;
    onClick: () => void;
};

const IndexCardsCard = (props: Properties) => {
    const { card, className, onClick } = props;

    let frontImage = <></>;
    if (card.frontImageId) {
        frontImage =
            <Image
                data={{
                    type: 'image',
                    id: card.frontImageId
                }}
            />;
    }
    let backImage = <></>;
    if (card.backImageId) {
        backImage =
            <Image
                data={{
                    type: 'image',
                    id: card.backImageId
                }}
            />;
    }
    return (
        <div onClick={onClick}>
            <div className={className}>
                <div className="term">
                    {frontImage}
                    <TextWithReferences text={card.term} />
                </div>
                <div className="desc">
                    {backImage}
                    <TextWithReferences text={card.desc} />
                </div>
            </div>
        </div>
    );
};

export default IndexCardsCard;
